// Libraries
import { Card, Grid } from '@chakra-ui/react';
// Components
import { RatingInfo } from '@molecules/index';
// Utils
import { RatingList } from '@utils/index';
// Translations
import text from '@translations/en.json';
// Type
import { RatingsSummaryProps } from './RatingsSummary.type';

/**
 * Renders a Ratings Summary component.
 * @component
 * @param {RatingsSummaryProps} props - The component props.
 * @param {Rating} props.ytdTotals - The YTD (Year-to-Date) ratings. Optional.
 * @param {Rating} props.eoyTotals - The EOY (End of Year) ratings. Optional.
 * @param {boolean} props.isLoading -  Indicates whether the component is in a loading state. Optional.
 * @returns {ReactElement} The RatingsIcon component.
 */
export const RatingsSummary = ({ ytdTotals, eoyTotals, isLoading }: RatingsSummaryProps) => {
  return (
    <Card w='full' justify='center' data-testid='ratings-summary'>
      <Grid
        gridTemplateColumns={{ base: '1fr 1fr', lg: 'repeat(5, 1fr)' }}
        p={{ base: 3, md: 5 }}
        gap={{ base: 3, xl: 10 }}
      >
        {RatingList.map((rating) => (
          <RatingInfo
            key={rating}
            rating={rating}
            title={`${ytdTotals?.[rating] ?? 0} ${text.current_ytd}`}
            description={`${eoyTotals?.[rating] ?? 0} ${text.forecasted_eoy}`}
            isLoading={isLoading}
          />
        ))}
      </Grid>
    </Card>
  );
};
